import {UserTracker} from "../index.js";

const eventDics = {
    "team": "main:project-invite-team:click", // 참여자 초대
    "email": "main:project-invite-email:click", // 이메일 초대장 발송
    "copy-link": "main:project-invite-copy-link:click", // 초대 링크 복사
}

export const ProjectInviteTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value: null, data: {}});
    }

    return Tracker;
}